import { identity } from 'lodash';
import { Fragment, type ReactNode } from 'react';

import { type Boundaries, segmentTextByBoundaries } from '@/src/lib/segmentTextByBoundaries';

interface Props {
    boundaries: Boundaries;
    children: string;
    highlight: (text: string) => ReactNode;
}

function Highlight({ boundaries, children: text, highlight }: Props) {
    const segments = segmentTextByBoundaries({
        boundaries,
        text,
        defaultSegmentWrapper: identity,
        boundedSegmentWrapper: highlight,
    });

    return Array.from(segments, (part, index) => <Fragment key={index}>{part}</Fragment>);
}

export default Highlight;
